/**
 * Created by vonsh on 2018/8/28
 */
import Home from '@/pc/Home'
import Technology from '@/pc/Technology';
import Production from '@/pc/Production';
import Solution from '@/pc/Solution';
import Case from '@/pc/Case';
import AboutUs from '@/pc/AboutUs'
import News from '@/pc/News'
import JoinUs from '@/pc/JoinUs'
import CompanyProfile from '@/pc/CompanyProfile'
import NewsDetails from '@/pc/NewsDetails.vue'

export default [
  {
    path: '/',
    name: 'Home',
    title: '一维大成科技有限公司',
    component: Home
  }, {
    path: '/tech',
    name: 'Tech',
    title: '核心技术',
    component: Technology
  }, {
    path: '/produc/:type',
    name: 'Production',
    title: '产品中心',
    component: Production
  }, {
    path: '/solution',
    name: 'Solution',
    title: '解决方案',
    component: Solution
  }, {
    path: '/case/:type',
    name: 'Case',
    title: '经典案例',
    component: Case
  }, {
    path: '/aboutUs',
    name: 'AboutUs',
    title: '关于我们',
    component: AboutUs
  }, {
    path: '/news',
    name: 'News',
    title: '资讯中心',
    component: News
  }, {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetails
  }, {
    path: '/joinUs',
    name: 'JoinUs',
    title: '加入我们',
    component: JoinUs
  }, {
    path: '/companyProfile',
    name: 'CompanyProfile',
    title: '公司简介',
    component: CompanyProfile
  }
]



// WEBPACK FOOTER //
// ./src/router/pc.js